import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["id", "onClick"]
const _hoisted_2 = {
  key: 0,
  class: "path-element-icon"
}
const _hoisted_3 = { class: "path-element-text" }

import { PathPresentedDataModel } from "@medapro-types/common/components/PathPresenter";
import _ from "lodash";
import { sha1 as hash } from "object-hash";
import { nextTick, reactive, ref, unref, watch, onMounted, onBeforeUnmount } from "vue";
import Icon from "./Icon.vue";

//#region General
type ViewModel = { goalWidth: number; filteredList: PathPresentedDataModel[] };

export default /*#__PURE__*/_defineComponent({
  __name: 'PathPresenter',
  props: {
    value: {},
    reducedVisual: { type: Boolean },
    noOverflowBehaviour: { type: Boolean },
    withoutReducing: { type: Boolean },
    dotsLinkStyle: { type: Boolean },
    ignoreIcons: { type: Boolean }
  },
  emits: ["elementClicked", "dotsClicked"],
  setup(__props: any, { emit: emits }) {

const props = __props;



//#endregion

//#region Refs
const selfElement = ref<HTMLDivElement | null>(null);
const pathElements = ref<HTMLDivElement[] | null>(null);
const pathSeperator = ref<HTMLDivElement[] | null>(null);

let observer: ResizeObserver | null = null;
//#endregion

//#region Viewmodel
const vm = reactive<ViewModel>({ goalWidth: 0, filteredList: [] });
//#endregion

//#region Interaction
const elementClicked = (entry: PathPresentedDataModel) => {
  if (entry.id == "...") emits("dotsClicked");
  else emits("elementClicked", entry);
  if (entry.click) {
    entry.click(entry);
  }
};
//#endregion

//#region Overflowing Handling
watch(
  () => props.value,
  (nv) => {
    let result = nv;

    if (result && result.length) {
      if (props.reducedVisual && result.length > 2) {
        const first = _.first(props.value);
        const last = _.last(props.value);
        if (first && last && first != last) result = [first, { id: "...", name: "..." }, last];
      }
      vm.filteredList = result;
    } else vm.filteredList = [];
  },
  { deep: true, immediate: true }
);

let pathElementsHash = hash(JSON.stringify(pathElements.value ? pathElements.value : ""));

watch(
  () => pathElements.value,
  (nv) => {
    const nvHash = hash(JSON.stringify(nv));
    if (nvHash != pathElementsHash) {
      pathElementsHash = nvHash;
      nextTick(reduceList);
    }
  },
  { deep: true }
);

const reduceList = () => {
  if (!props.withoutReducing && !props.reducedVisual && selfElement.value) {
    let list = _.cloneDeep(vm.filteredList);
    const parent = selfElement.value.parentElement;
    if (!parent) return;

    vm.goalWidth = parent.getBoundingClientRect().width;
    let currentWidth = selfElement.value.getBoundingClientRect().width;
    const _pathElements = unref(pathElements.value);
    if (_pathElements && currentWidth > vm.goalWidth) {
      list = list.filter((x) => !_.isEmpty(x.id));
      while (currentWidth > vm.goalWidth && list.length > 2) {
        const element = _pathElements.shift();
        if (!element) break;
        const elementWidth = element.getBoundingClientRect().width + 30;
        currentWidth = currentWidth - elementWidth;
        list.shift();
      }
      if (list.length > 1) list[0] = { id: "...", name: "..." };
    }
    vm.filteredList = list;
  }
};

const handleParentResize = _.throttle(() => {
  reduceList();
}, 200);
//#endregion

//#region LifeCycle
onMounted(() => {
  const parent = selfElement.value?.parentElement;
  if (parent && !props.noOverflowBehaviour) {
    observer = new ResizeObserver(() => {
      handleParentResize();
    });
    observer.observe(parent);
  }
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
    observer = null;
  }
});
//#endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "path-presenter",
    ref_key: "selfElement",
    ref: selfElement
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.filteredList, (entry, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: entry.id
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["path-element", { link: entry.click != undefined || (entry.id == '...' && _ctx.dotsLinkStyle) }]),
          ref_for: true,
          ref_key: "pathElements",
          ref: pathElements,
          id: entry.id,
          style: _normalizeStyle({ maxWidth: `${vm.goalWidth - 60}px` }),
          onClick: ($event: any) => (elementClicked(entry))
        }, [
          (entry.icon && !_ctx.ignoreIcons)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                _createVNode(Icon, {
                  icon: entry.icon
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(entry.name), 1)
        ], 14, _hoisted_1),
        (index != vm.filteredList.length - 1)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "path-seperator",
              ref_for: true,
              ref_key: "pathSeperator",
              ref: pathSeperator
            }, [
              _createVNode(Icon, {
                icon: "ChevronRight",
                size: "14px"
              })
            ], 512))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 512))
}
}

})